import { FundClosingDrawdownType } from '__generated__/graphql';

import DataTable from 'components/DataTable';

import LoadingIndicator from 'primitives/LoadingIndicator';
import SlideOver from 'primitives/SlideOver';

const FundClosingDrawdown = ({
  showDrawdown,
  setShowDrawdown,
  fundClosingDrawdown,
  loading,
}: {
  showDrawdown: boolean;
  setShowDrawdown: (show: boolean) => void;
  fundClosingDrawdown: FundClosingDrawdownType[];
  loading?: boolean;
}) => {
  return (
    <SlideOver
      open={showDrawdown}
      onClose={() => setShowDrawdown(false)}
      title="Drawdown Details"
      subTitle="View and manage the details of this Commitment"
    >
      <div>
        {loading ? (
          <LoadingIndicator />
        ) : (
          <DataTable
            data={fundClosingDrawdown}
            columns={[
              {
                label: 'Status',
                fieldName: 'status',
                type: 'STATUS',
              },
              {
                label: 'Amount',
                fieldName: 'amount',
                type: 'CURRENCY',
              },
              // {
              //   label: 'Invested On',
              //   fieldName: 'createdAt',
              //   type: 'DATE',
              // },
              {
                label: 'Transferred On',
                fieldName: 'drawdownDate',
                type: 'DATE',
              },
            ]}
          />
        )}
      </div>
    </SlideOver>
  );
};

export default FundClosingDrawdown;
